import React from 'react';
import { Link } from '@/components/LocalizedLink';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { fadeLeft, fadeRight, revealOnce } from '@/lib/motion';

const POINTS = [
  'Direct farm sourcing from Maharashtra',
  'FSSAI & APEDA certified facilities',
  'Lab-tested for purity & safety',
  'Flexible packaging options',
  'Competitive FOB pricing',
];

function WhyUsPoints() {
  return (
    <ul className="mt-6 space-y-3">
      {POINTS.map((item, i) => (
        <motion.li
          key={item}
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 + i * 0.1 }}
          className="flex items-center gap-3 text-sm text-earth/70 font-sans"
        >
          <CheckCircle size={16} className="text-saffron flex-shrink-0" />
          {item}
        </motion.li>
      ))}
    </ul>
  );
}

export default function WhyUsPreview({ sourcingImg }) {
  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-saffron-50/50 overflow-hidden" data-testid="why-us-preview">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div {...revealOnce} variants={fadeLeft} transition={{ duration: 0.7 }} className="relative">
            <img src={sourcingImg} alt="Export-grade spice powders packed for shipment" width={1264} height={848} className="w-full rounded-lg shadow-card-lift" loading="lazy" />
            <div className="absolute -bottom-4 -right-4 bg-saffron text-white rounded-lg p-4 shadow-lg">
              <p className="font-display text-3xl font-bold">100%</p>
              <p className="text-xs font-sans text-white/80">Quality Assured</p>
            </div>
          </motion.div>
          <motion.div {...revealOnce} variants={fadeRight} transition={{ duration: 0.7 }}>
            <span className="text-xs uppercase tracking-[0.3em] text-saffron font-sans font-semibold">Why Choose Us</span>
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-earth-dark mt-3 tracking-tight">
              Farm-to-Export Excellence
            </h2>
            <p className="mt-4 text-earth/60 font-sans leading-relaxed">
              We maintain complete traceability from farm to port, ensuring every shipment meets international quality standards and your specific requirements.
            </p>
            <WhyUsPoints />
            <Link to="/why-choose-us" className="mt-8 inline-flex items-center gap-2 text-saffron font-sans font-semibold text-sm hover:text-saffron-dark transition-colors" data-testid="learn-more-why">
              Learn More About Our Process <ArrowRight size={14} />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
